import { useMutation } from '@tanstack/react-query';
import {
  completeV2Assessment,
  saveV2Progress,
  type SaveV2ProgressBody,
} from '../api/v2TakeApi';

/**
 * MVP 2 take-flow mutations (Feature 110).
 *
 * Loading is not here: both versions are fetched by `useAssessmentByToken`,
 * because the client opens one URL and only the response says which version it
 * is. Only the writes differ, so only the writes are duplicated.
 */

/** Save progress — discovery answers, readiness answers, or both. */
export function useSaveV2Progress(token: string) {
  return useMutation({
    mutationFn: (body: SaveV2ProgressBody) => saveV2Progress(token, body),
  });
}

/** Finish: scores, snapshots the priorities, and records the sharing choice. */
export function useCompleteV2Assessment(token: string) {
  return useMutation({
    mutationFn: (declineSharing: boolean) => completeV2Assessment(token, declineSharing),
  });
}
